module.exports = __webpack_public_path__ + "img/suitcase.6ededec0.svg";